module.exports = __webpack_public_path__ + "img/20210906-1630898345510927.2505a061.jpg";